import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Public approve/reject page reached from the approval email link:
 *   /approve?t=<token>[&d=approve|reject]
 * No login required — the signed token authorises exactly one decision.
 */
export default function Approve() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("t") || "";
  const preset = (params.get("d") || "").toLowerCase();

  const [state, setState] = useState({ loading: true, error: "", ticket: null, status: null });
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setState({ loading: false, error: "This approval link is missing its code." }); return; }
    api.approvalInfo(token)
      .then((r) => setState({ loading: false, error: "", ticket: r.ticket, status: r.approval?.status }))
      .catch((e) => setState({ loading: false, error: e.message || "This approval link is invalid or has expired." }));
  }, [token]);

  const decide = async (decision) => {
    setSaving(true);
    try {
      const r = await api.approvalDecide(token, decision, note);
      setState((p) => ({ ...p, status: r.status || r.already || decision }));
    } catch (e) {
      setState((p) => ({ ...p, error: e.message || "Could not record your decision." }));
    } finally { setSaving(false); }
  };

  const wrap = { minHeight: "100vh", display: "grid", placeItems: "center", background: "#f6f8fc", padding: 24, fontFamily: "Inter, system-ui, sans-serif" };
  const card = { width: "100%", maxWidth: 480, background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 10px 40px rgba(13,26,58,.08)", border: "1px solid #eef1f7" };

  if (state.loading) return <div style={wrap}><div style={card}>Loading…</div></div>;
  if (state.error) return <div style={wrap}><div style={card}><h2 style={{ margin: 0, color: "#0D1A3A" }}>Approval unavailable</h2><p style={{ color: "#5b6b8c" }}>{state.error}</p></div></div>;

  const done = state.status && state.status !== "pending";
  if (done) return (
    <div style={wrap}><div style={{ ...card, textAlign: "center" }}>
      <div style={{ fontSize: 40 }}>{state.status === "approved" ? "✓" : "✕"}</div>
      <h2 style={{ margin: "8px 0", color: "#0D1A3A" }}>Request {state.status}</h2>
      <p style={{ color: "#5b6b8c" }}><b>{state.ticket?.ticket_no}</b> — {state.ticket?.title}</p>
    </div></div>
  );

  return (
    <div style={wrap}><div style={card}>
      <p style={{ color: "#0654FC", fontWeight: 600, margin: 0, fontSize: 13 }}>{state.ticket?.ticket_no}</p>
      <h2 style={{ margin: "4px 0 2px", color: "#0D1A3A" }}>Approval requested</h2>
      <p style={{ color: "#5b6b8c", marginTop: 0 }}>{state.ticket?.title}</p>

      <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3}
        placeholder="Add a note (optional)"
        style={{ width: "100%", boxSizing: "border-box", borderRadius: 10, border: "1px solid #dce1ec", padding: 12, resize: "vertical", fontFamily: "inherit", marginTop: 8 }} />

      <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
        <button disabled={saving} onClick={() => decide("approve")}
          style={{ flex: 1, padding: "12px", borderRadius: 10, border: "none", background: "#1BA85C", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
          {saving ? "…" : "Approve"}
        </button>
        <button disabled={saving} onClick={() => decide("reject")}
          style={{ flex: 1, padding: "12px", borderRadius: 10, border: "none", background: "#c0392b", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
          {saving ? "…" : "Reject"}
        </button>
      </div>
      {preset && <p style={{ fontSize: 12, color: "#96a1b8", marginTop: 10, textAlign: "center" }}>You clicked “{preset}” — confirm above.</p>}
    </div></div>
  );
}
